import React from 'react';
import {Container, Paper} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import EventForm from "./EventForm";
import RoutingPointsStepper from "../core/shipments/RoutingPointsStepper";
import ParticipantsExpansionPanel from "../page-single-shipment-details/ParticipantsExpansionPanel";
import ShipmentInfoCard from "../page-single-shipment-tracking/ShipmentInfoCard";
import {useParams} from "react-router-dom";
import {getShipmentInfo, getShipmentSummary} from "../../api/ShipmentEndpoint";
import {RR_STATUS} from "../../constants/RRConstants";
import {useSnackbar} from "notistack";
import {useTranslation} from "react-i18next";
import {IShipmentSummary} from "../../pages/SingleShipmentTrackingPage";
import {IShipment} from "../core/shipments/ShipmentList";
import Loader from "../core/Loader";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flex: 1
        },
        innerGrid: {
            display: "flex",
            marginTop: 20,
            padding: 10,
            "& .MuiGrid-container": {
                justifyContent: "center"
            }
        }
    }),
);

type EventCreateProps = {
    setShipment: (shipment) => void
    formRef: any
}

const EventCreatePageComponents: React.FC<EventCreateProps> = ({setShipment, formRef}) => {
    const {uuid, shipmentId} = useParams();
    const {enqueueSnackbar} = useSnackbar();
    const {t} = useTranslation();
    const classes = useStyles();
    const [shipmentInfo, setShipmentInfo] = React.useState<IShipment | undefined>(undefined);
    const [shipmentSummary, setShipmentSummary] = React.useState<IShipmentSummary | undefined>(undefined);

    React.useEffect(() => {
        if (!uuid) return;
        getShipmentSummary(uuid).then(({data}) => {
            const {status, response} = data;

            if (status !== RR_STATUS.OK) {
                enqueueSnackbar(t("core.server-error"), {
                    variant: "error",
                    preventDuplicate: false
                });
            } else {
                setShipmentSummary(response);
            }
        });

        getShipmentInfo(uuid).then(({data}) => {
            const {status, response} = data;

            if (status !== RR_STATUS.OK) {
                enqueueSnackbar(t("core.server-error"), {
                    variant: "error",
                    preventDuplicate: false
                });
            } else {
                setShipmentInfo(response);
                setShipment(response);
            }
        })
    }, [enqueueSnackbar, t, setShipmentSummary, setShipment, uuid]);

    return (
        <Container className={classes.root}>
            <Grid container spacing={2}>

                <Grid container item xs={12}>
                    <Grid container item className={classes.innerGrid} component={Paper}>
                        <Grid item md={6}>
                            <EventForm shipmentId={shipmentId} formRef={formRef}/>
                        </Grid>
                        <Grid container item md={6}>
                            <Grid item md={6}>
                                {shipmentInfo ?
                                    <RoutingPointsStepper routingPoints={shipmentInfo?.routingPoints} isVertical/> :
                                    <Loader/>}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    {uuid && <ParticipantsExpansionPanel uuid={uuid}/>}
                </Grid>

                <Grid item xs={12}>
                    <ShipmentInfoCard shipmentSummary={shipmentSummary}/>
                </Grid>
            </Grid>
        </Container>
    );
};

export default EventCreatePageComponents;